module.exports = __webpack_public_path__ + "img/AMS.5c6be1ce.png";